<template>
  <div style="position: relative; z-index: 999;">
    <header>
      <div class="loading" v-if="processing">
        <div class="load">
          <hr><hr><hr><hr>
          <div class="loadback"></div>
        </div>
      </div>
      <div class="container" v-if="!user && showPublicHeader">
        <div class="row d-flex align-items-center mob-head">
          <div class="col-lg-3 col-md-3 col-3" v-if="!showHeader">
            <a href="https://www.b1g1.com/" target="_blank" rel="noopener">
              <img class="d-logo" src="/static/front/images/b1g1-logo-blue.png" alt="alt" style="cursor:pointer;"
                   height="66.45px" width="174px">
            </a>
            <a href="https://www.b1g1.com/" target="_blank" rel="noopener">
              <img class="m-logo" src="/static/front/images/b1g1-light-widget.png" alt="alt">
            </a>
          </div>
          <div class="col-lg-6 col-md-3 text-center" v-if="!showHeader && !user">
            <ul class="desktop-main-menu"
                :class="[(isDrawerOpen) ? 'active' : '', ((isMobile) || (isIpad)) ? 'p-user-sec-mobile': '']">
              <li><a href="https://b1g1.com/the-b1g1-model" target="_blank">HOW IT WORKS</a></li>
              <li class="headerMobile-ipad header-deks" v-if="window.width >= 1025">
                <a href="#">Causes
                  <i class="fas fa-caret-down"></i>
                </a>
                <ul class="sub-menu">
                  <li><a href="https://b1g1.com/b1g1-projects" target="_blank">B1G1 Projects</a></li>
                  <li><a href="https://b1g1.com/impacts" target="_blank">THE IMPACTS</a></li>
                  <li><a href="https://b1g1.com/sustainable-development-goals" target="_blank">SUSTAINABLE DEVELOPMENT GOALS</a></li>
                </ul>
              </li>
              <li v-if="(isMobile) || (isIpad)">
                <a href="javascript:;" @click="showCauses = !showCauses">Causes<i class="fas fa-caret-down"></i></a>
                <ul class="mobile-submenu" :class="{ show: showCauses }">
                  <li><a href="https://b1g1.com/b1g1-projects" target="_blank">B1G1 Projects</a></li>
                  <li><a href="https://b1g1.com/impacts" target="_blank">THE IMPACTS</a></li>
                  <li><a href="https://b1g1.com/sustainable-development-goals" target="_blank">SUSTAINABLE DEVELOPMENT
                    GOALS</a></li>
                </ul>
              </li>
              <li class="headerMobile-ipad header-deks" v-if="window.width >= 1025">
                <a href="#">Community<i class="fas fa-caret-down"></i></a>
                <ul class="sub-menu"
                    :class="[(isDrawerOpen) ? 'active' : '', ((isMobile) || (isIpad)) ? 'mob-sub': '']">
                  <li>
                    <router-link :to="{ name: 'business-listing'}">B1G1 MEMBERS</router-link>
                  </li>
                  <li><a href="https://b1g1.com/partnerships" target="_blank">Our Partners</a></li>
                  <!-- <li><a href="https://b1g1.com/the-team" target="_blank">THE TEAM</a></li>
                  <li><a href="https://b1g1.com/careers" target="_blank">WORK WITH B1G1</a></li> -->
                  <li><a href="https://b1g1.com/events/overview" target="_blank">EVENTS</a></li>
                  <li><a href="https://blog.b1g1.com/" target="_blank">Blog And Stories</a></li>
                </ul>
              </li>
              <li v-if="(isMobile) || (isIpad)">
                <a href="javascript:;" @click="showCommunityTab()">Community<i
                  class="fas fa-caret-down"></i></a>
                <ul class="mobile-submenu" :class="{ show: showCommunity }">
                  <li>
                    <router-link :to="{ name: 'business-listing'}">B1G1 MEMBERS</router-link>
                  </li>
                  <li><a href="https://b1g1.com/partnerships" target="_blank">Our Partners</a></li>
                  <!-- <li><a href="https://b1g1.com/the-team" target="_blank">THE TEAM</a></li>
                  <li><a href="https://b1g1.com/careers" target="_blank">WORK WITH B1G1</a></li> -->
                  <li><a href="https://b1g1.com/events/overview" target="_blank">EVENTS</a></li>
                  <li><a href="https://blog.b1g1.com/" target="_blank">Blog And Stories</a></li>
                </ul>
              </li>
              <li><a href="https://blog.b1g1.com/" target="_blank">Blog</a></li>
              <!--<li><a href="/login" class="">Login</a></li>
              <li class="b-btn red-btn"><a href="/logihttps://b1g1.com/join-us" class="">Join Us</a></li>-->
            </ul>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 col-8 text-right mob-right-sec" v-if="!user">
            <router-link class="login-btn" :to="{ name: 'login'}">Login</router-link>
            <li class="b-btn red-btn"><a href="https://b1g1.com/join-us" target="_blank" style="text-transform: uppercase; margin: 0 !important;" class="login-btn">Join Us</a></li>
            <div class="toggle" :class="(isDrawerOpen) ? 'change' : ''" @click="openMenuDrawer()">
              <div class="bar1"></div>
              <div class="bar2"></div>
              <div class="bar3"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="container" v-if="showHeader" style="position: relative;" >
        <div class="row d-flex align-items-center">
          <div class="col-md-3 col-5 d-none">
            <img alt="alt" class="d-logo" src="/static/front/images/b1g1-logo-blue.png"
                 @click="$router.push({ name: 'impact'})" style="cursor:pointer;" height="66.45px" width="174px">
            <img alt="alt" class="m-logo" src="/static/front/images/b1g1-light-widget.png"
                 @click="$router.push({ name: 'impact'})" style="cursor:pointer;">
          </div>
          <div class="col-md-5 col-5">
            <div class="mobile-menu-list">
              <!-- <div class="toggle" :class="(isDrawerOpen) ? 'change' : ''" @click="openMenuDrawer()" > -->
              <div class="toggle" :class="(isDrawerOpen) ? 'change' : ''" @click="toggleMenu">
                <div class="bar1"></div>
                <div class="bar2"></div>
                <div class="bar3"></div>
              </div>
              <RouterLink to="/" @click.native="closeMenu">
                <img class="businessLogo" src="/static/front/images/menu-images/b1g1-logo.svg" alt="alt">
                <img class="personalLogo" src="/static/front/images/menu-images/b1g1-logo-2.svg" alt="alt">
              </RouterLink>
            </div>
            <search :user="user"></search>
          </div>
          <div class="col-md-7 col-7 d-flex align-items-center justify-content-end" v-if="user && showRoutes">
            <!-- <ul class="desktop-main-menu d-xl-none" :class="[(isDrawerOpen) ? 'active' : '', (user.account === 'user' && (isMobile) || (isIpad)) ? 'p-user-sec-mobile': '']">
              <menuCustom></menuCustom>
            </ul> -->
           <div class="noti">
              <router-link :to="{ name: 'giving-cart'}" rel="noopener" @click.native="closeCart" style="margin-right: 2.5px;">
                <aside class="cart">
                  <div>
                    <em id="cartnumber" v-if="getCartCount > 0">{{ getCartCount }}</em>
                    <img src="/static/front/images/menu-images/basket-icon.svg" alt="">
                    <!-- <i class="fas fa-shopping-basket"></i> -->
                  </div>
                </aside>
              </router-link>
              <aside id="myDiv2" class="notifation" style="margin: 3px 0 0;">
                <div>
                  <em id="notificationnumber" v-if="cntNotification">{{ cntNotification }}</em>
                  <img src="/static/front/images/menu-images/cart.svg" alt=""  @click="closeNoti">
                  <!-- <i class="fas fa-bell"></i> -->
                </div>
              </aside>
            </div>
            <div :class="user.account === 'company' ? 'user-sec' : 'user-sec p-user-sec'" v-if="user">
              <div v-if="user.account === 'company'" class="notification-wrapper">
                <span>{{ companyName.charAt(0) }}</span>
                <h4 style="width: 155px;">{{
                    companyName.length > 25
                      ? companyName.substr(0, 25) + '...'
                      : companyName
                  }}</h4>
              </div>
              <div v-if="user.account !== 'company'" class="notification-wrapper">
                <span>{{ user.first_name.charAt(0) }}</span>
                <h4 style="width: 155px;">{{
                    user.first_name.length > 25
                      ? user.first_name.substr(0, 25) + '...'
                      : user.first_name
                  }}</h4>
              </div>
              <div v-if="user.account === 'company'" class="notification-wrapper">
                <p>Business Account</p>
                <ul>
                  <li v-if="isAdminLogin">
                    <a class="pointer" @click="adminAccount()"><img src="/static/front/images/drop-down-icon/admin-account.svg" alt="">Back to Admin Account</a></li>
                  <li v-if="user.user_business.company_id">
                    <router-link @click.native="clickRightMenuClose()" class="" :to="{ name: 'business.company.profile'}"><img src="/static/front/images/drop-down-icon/company-profile.svg" alt=""> Company Profile</router-link>
                  </li>
                  <li
                    v-if="(user.user_business && user.user_business.is_admin && user.user_business.is_business === 0)">
                    <router-link @click.native="clickRightMenuClose()" class="" :to="{ name: 'billing-details'}"><img src="/static/front/images/drop-down-icon/billing.svg" alt="">Billing</router-link>
                  </li>
                  <li v-if="!isDowngradeUser">
                    <router-link @click.native="clickRightMenuClose()" class="" :to="{ name: 'impact-reminders'}"><img src="/static/front/images/drop-down-icon/alarm-clock.svg" alt="">Your Giving Reminders</router-link>
                  </li>
                  <li v-if="user.id === compnayOwnerId">
                    <router-link @click.native="clickRightMenuClose()" class="" :to="{ name: 'reset-password'}"><img src="/static/front/images/drop-down-icon/check.svg" alt="">Login & Password Setting</router-link>
                  </li>
                  <li><a href="javascript:void(0)" @click="logout()"><img src="/static/front/images/drop-down-icon/log-out.svg" alt="">Log Out</a></li>
                  <li v-if="user.user_business.company_id" class="switch-to-personal">
                    <a class="pointer" @click="personalAccount()">Switch to Personal Account</a>
                  </li>
                </ul>
                <ul class="d-none">
                  <li v-if="isAdminLogin">
                    <a class="pointer" @click="adminAccount()">Back to Admin Account</a></li>
                    <li v-if="user.user_business.company_id">
                      <a href="javascript:void(0)" @click="personalAccountProfile()">Personal Profile & Settings</a>
                    </li>
                  <li v-if="(user.user_business && user.user_business.is_admin && user.user_business.is_business === 0)">
                    <router-link class="" :to="{ name: 'impact.history'}" @click.native="clickRightMenuClose()">Impact History</router-link>
                  </li>
                  <li v-if="user.id === compnayOwnerId">
                    <router-link class="" :to="{ name: 'reset-password'}" @click.native="clickRightMenuClose()">Login & Password Setting</router-link>
                  </li>
                  <li v-if="user.user_business.company_id">
                    <a class="pointer" @click="personalAccount()">Switch to Personal Account</a>
                  </li>
                  <li class="menu-ti" v-if="(user.user_business.is_admin && user.user_business.is_business === 0)">
                    Company
                  </li>
                  <li v-if="(user.user_business.is_admin && user.user_business.is_business === 0)">
                    <router-link class="" :to="{ name: 'business.company.profile'}" @click.native="clickRightMenuClose()">Company Profile</router-link>
                  </li>
                  <li v-if="(user.user_business && user.user_business.is_admin && user.user_business.is_business === 0)">
                    <router-link v-if="company && company.token_management_access === '1'" class="" :to="{ name: 'token-management'}" @click.native="clickRightMenuClose()">Token Management</router-link>
                  </li>
                  <li
                    v-if="(user.user_business && user.user_business.is_admin && user.user_business.is_business === 0)">
                    <router-link class="" :to="{ name: 'impact.history'}" @click.native="clickRightMenuClose()">Impact History</router-link>
                  </li>
                  <li
                    v-if="(user.user_business && user.user_business.is_admin && user.user_business.is_business === 0)">
                    <router-link v-if="company && company.token_management_access === '1'" class=""
                                 :to="{ name: 'token-management'}" @click.native="clickRightMenuClose()">Token Management
                    </router-link>
                    <a v-if="company && company.token_management_access === '0'" class="header-menu-disable"
                       v-tooltip.top="{ content: 'Upgrade to access', class: 'normal-tooltip' }">Token Management</a>
                  </li>
                  <li
                    v-if="(user.user_business && user.user_business.is_admin && user.user_business.is_business === 0)">
                    <router-link class="" :to="{ name: 'team-accounts-management'}" @click.native="clickRightMenuClose()">Team Accounts Management
                    </router-link>
                  </li>
                  <li
                    v-if="(user.user_business && user.user_business.is_admin && user.user_business.is_business === 0)">
                    <router-link class="" :to="{ name: 'billing-details'}" @click.native="clickRightMenuClose()">Billing</router-link>
                  </li>
                  <li><a href="javascript:void(0)" @click="logout()"><i class="fas fa-sign-out-alt"></i>Log Out</a></li>
                  <!--                  <li class="switch-menu"><a class="pointer" :href="oldHost" target="_blank">SWITCH TO CLASSIC VERSION</a></li>-->
                </ul>
              </div>
              <div v-if="user.account !== 'company'">
                <p>Personal Account</p>
                <ul>
                  <li v-if="isAdminLogin">
                    <a class="pointer" @click="adminAccount()"><img src="/static/front/images/drop-down-icon/admin-account.svg" alt="">Back to Admin Account</a>
                  </li>
                  <li>
                    <router-link class="" :to="{ name: 'business.personal.profile'}" @click.native="clickRightMenuClose()"><img src="/static/front/images/drop-down-icon/company-profile.svg" alt="">Personal Profile & Settings
                    </router-link>
                  </li>
                  <li>
                    <router-link class="" :to="{ name: 'impact.history'}" @click.native="clickRightMenuClose()"><img src="/static/front/images/drop-down-icon/alarm-clock.svg" alt="">Impact History</router-link>
                  </li>
                  <li v-if="!isDowngradeUser">
                    <router-link @click.native="clickRightMenuClose()" class="" :to="{ name: 'impact-reminders'}"><img src="/static/front/images/drop-down-icon/alarm-clock.svg" alt="">Your Giving Reminders</router-link>
                  </li>
                  <li>
                    <router-link class="" :to="{ name: 'business.personal.reset-password'}" @click.native="clickRightMenuClose()"><img src="/static/front/images/drop-down-icon/check.svg" alt="">Login & Password Setting</router-link>
                  </li>
                  <li><a href="javascript:void(0)" @click="logout()"><img src="/static/front/images/drop-down-icon/log-out.svg" alt="">Log Out</a></li>
                  <!--                  <li class="switch-menu"><a class="pointer" :href="oldHost" target="_blank">SWITCH TO CLASSIC VERSION</a></li>-->
                  <li v-if="user.user_business && user.user_business.company_id && parseInt(user.user_business.is_admin)" class="switch-to-personal">
                    <a class="pointer" @click="companyAccount()">Switch to Business Account</a>
                  </li>
                </ul>
              </div>
              <i class="fas fa-caret-down">
                <img src="/static/front/images/menu-images/down-arrow.svg" alt="alt">
              </i>
            </div>
            <div class="user-sec" v-else>
              <span>G</span>
              <h4>Guest <a href="#" @click="logout()" style="color: white; font-size: 18px;"><i
                class="fas fa-sign-out-alt"></i></a></h4>
            </div>
            <div class="dot-cion-menu" @click="toggleRightMenu">
              <img src="/static/front/images/drop-down-icon/menu-dots-icon.svg" alt="alt">
            </div>
          </div>
          <headerDisable class="col-md-7 col-7 d-flex align-items-center justify-content-end" v-if="user && !showRoutes"></headerDisable>
        </div>
        <div id="myDiv" class="notification-blog" v-if="showNotification">
          <div class="row">
            <div class="col-6 col-md-6 col-xl-6 ">
              <h3 style="margin:0">Your Notifications</h3>
            </div>
            <div class="col-6 col-md-6 col-xl-6 text-right d-flex align-items-center justify-content-end ">
              <button @click="readNotification(0, null)" v-if="notifications.length > 0"><img src="/static/front/images/menu-images/approve-tick.svg" alt="">MARK ALL AS READ</button>
            </div>
          </div>
          <div class="noti_scroll" v-if="notifications.length > 0" @scroll="handleScroll">
            <div v-for="(notification,index) in notifications" :key="index" :data="notification.id"
                 :class=" (notification.status === '1') ? 'row readNoti' : 'row unreadNoti' "
                 @click="readNotification(1, notification)">
              <div class="col-md-11 notification-bulets">
                <div class="notification-title" v-if="notification.broadcast_notification">
                  {{ notification.broadcast_notification.title }}
                  <a :href="notification.broadcast_notification.external_link" target="_blank"
                  @click="externalLink($event)"
                  v-if="notification && notification.broadcast_notification && notification.broadcast_notification.external_link !== ''">
                  <i class="fas fa-external-link-alt" style="font-size:12px; padding-left:0px;"></i>
                  </a>
                </div>
                <div class="noti-date">
                  {{ getDateFormat(notification.notification_date) }}
                </div>
                <div class="notification-body">
                  {{ notification.broadcast_notification.message_body }}
                </div>
              </div>
              <div class="trash-alt-wrapper">
                <a class="white-btn" @click="deleteNotification(notification)" href="javascript:void(0)"><i
                  class="far fa-trash-alt"></i></a>
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-md-12 readNoti">
              <div class="notification-body ">
                No messages to display
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <transition name="fade" v-if="showHeader && bannerData && bannerData.header">
        <div v-if="showUSDAlert === 'true'" v-html="bannerData.header.title"
             class="event_banner">
        </div>
      </transition> -->
      <div class="blue-strip-text" v-if="showHeader && bannerData">
        <p v-html="bannerData.title"></p>
      </div>
    </header>
    <div class="overly-close" @click="toggleRightMenu"></div>
    <RouterLink to="" class="overly-close" @click.native="closeMenu"></RouterLink>
    <menuCustom v-if="user && showRoutes" :partner_level="partner_level" :user="user" :isHivePartner="isHivePartner" :companyName="companyName" :totalImpacts="totalImpacts"></menuCustom>
    <v-dialog name="gift" height="auto" :scrollable="false">
      <div class="toast-title">Gifted</div>
      <div class="toast-message">A special Giving Credit of US $100.00 has been added to your account!</div>
    </v-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import store from '../../store'
import config from '../../config/app'
import userApi from '../../api/user'
import bannerAPI from '../../api/banners'
/* import storyAPI from '../../api/story' */
import companyApi from '../../api/company'
import contributionApi from '../../api/contribution'
import NotificationMixin from '../../helper/mixin/Notification'
// import creditAPI from '../../api/credit'
import tokenAPI from '../../api/token'
// import appAPI from '../../api/app'
import headerDisable from './HeaderDisable'
import {mapGetters} from 'vuex'
import Hotjar from 'vue-hotjar'
import vmodal from 'vue-js-modal'
import moment from 'moment'
import $ from 'jquery'
import menuCustom from '../business/menu-custom.vue'
import search from '../business/SearchKeyword.vue'

window.$ = window.jQuery = $
Vue.use(vmodal, {dialog: true})
let urlName = window.location.href
let pageName = 'frontgivingwidget/'
if (urlName.includes(pageName) === false) {
  Vue.use(Hotjar, {
    id: config.hotjar_id, // Hotjar Site ID
    isProduction: true,
    snippetVersion: 6
  })
}
export default {
  computed: {
    ...mapGetters({
      getCartCount: 'getCartCount'
    })
  },
  components: {
    headerDisable,
    menuCustom,
    search
  },
  mixins: [NotificationMixin],
  data () {
    return {
      showCommunity: false,
      showImpactlist: true,
      showCauses: false,
      processing: false,
      isrestrictCountry: false,
      currentYear: new Date().getFullYear(),
      charityCountry: config.charity_disclosure_countries,
      user: (store.getters.currentUser) ? store.getters.currentUser : null,
      type: (store.getters.currentUser) ? store.getters.currentUser.account : null,
      campaign_access_flag: (store.getters.currentUser) ? store.getters.currentUser.campaign_access_flag : null,
      engagement_access_flag: (store.getters.currentUser && store.getters.currentUser.companydata) ? store.getters.currentUser.companydata.engagement_access : null,
      company: null,
      isValidCurrentPage: (this.$route.path !== '/sign-up' && this.$route.path !== '/join-business-geniusu' && this.$route.name !== 'public-business-register' && this.$route.name !== 'payment-redirect' && this.$route.name !== 'payment-redirect-new' && this.$route.name !== 'campaign-payment-success') ? 1 : 0,
      notShowHeaderRouteNames: ['payment-redirect', 'payment-redirect-new', 'public-business-register'],
      notShowBanner: ['public-join-business', 'public-join-business-geniusu', 'campaign-payment-success'],
      showHeader: false,
      showNotification: false,
      showPublicHeader: false,
      animate: false,
      isHivePartner: 0,
      cntNotification: 0,
      isDrawerOpen: false,
      isAdminLogin: false,
      isMobile: store.getters.isMobile,
      compnayOwnerId: 0,
      showRoutes: false,
      totalImpacts: 0,
      totalImpactsCount: 1,
      totalImpact: 0,
      totalGivings: 0,
      totalGivingsammout: 0,
      partner_level: (store.getters.currentUser && store.getters.currentUser.companydata) ? store.getters.currentUser.companydata.latest_impact_partner_level : null,
      bannerData: null,
      isDowngradeUser: store.getters.currentUser ? store.getters.currentUser.role_id === 1 : false,
      companyName: '',
      oldHost: 'https://www.b1g1.com/login',
      form: {
        username: localStorage.getItem('YUJAqQWVZTRRJsvPpKIG') ? localStorage.getItem('YUJAqQWVZTRRJsvPpKIG') : null,
        password: localStorage.getItem('VxdqRJrxxGTZSSwFmmOU') ? localStorage.getItem('VxdqRJrxxGTZSSwFmmOU') : null
      },
      filters: {
        limit: 5,
        page: 1,
        order_automate: '',
        order_automate_by: '',
        is_giving_monthly: '1',
        order_by_field: 'updated_at',
        order_by: 'desc'
      },
      notifications: [],
      // notifications1: [],
      filter: { // notications
        limit: 10,
        page: 1
      },
      isIpad: store.getters.isIpads,
      showUSDAlert: 'false',
      window: {
        width: 0,
        height: 0
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    // var ratio = window.devicePixelRatio || 1
    // var screen = {
    //   width: window.screen.width * ratio,
    //   height: window.screen.height * ratio
    // }
    // if ((screen.width === 1668 && screen.height === 2388) || (screen.width === 2048 && screen.height === 2732) || (screen.width === 1024 && screen.height === 1366) || (screen.width === 834 && screen.height === 1194)) {
    //   this.isIpad = true
    // }
    // Start of b1g1 Zendesk Widget script
    /* let zendeskjs = document.createElement('script')
    zendeskjs.setAttribute('id', 'ze-snippet')
    zendeskjs.setAttribute('src', 'https://static.zdassets.com/ekr/snippet.js?key=b69d5261-aa9f-4270-a379-95948de761d6')
    document.body.appendChild(zendeskjs) */
    // End of b1g1 Zendesk Widget script
    if (this.user !== null) {
      if (this.user.companydata) {
        if (this.charityCountry && this.charityCountry.includes(this.user.companydata.country_name)) {
          this.isrestrictCountry = true
        } else {
          this.isrestrictCountry = false
        }
      }
    }
    if (localStorage.getItem('login_user_type') !== '' && localStorage.getItem('login_user_type') === 'admin') {
      this.isAdminLogin = true
    }
    if (!this.user) {
      if (this.notShowHeaderRouteNames.includes(this.$route.name)) {
        this.showPublicHeader = false
      } else {
        this.showPublicHeader = true
      }
    }
    /* let favProjectsPromise = null */
    // check for the fav projects
    let companyPromise = null
    let tokenPromise = null
    let bannerPromise = null
    let companyOwnerPromise = this.getCompnayOwner()
    // let contributionsPromise = this.loadContributions()
    if (this.user) {
      if (this.user.role_id === 1) {
        if (this.$route.name !== 'profile.upgrade' && this.$route.name !== 'profile.upgrade-trial' && this.$route.name !== 'impact' && this.$route.name !== 'home' && this.$route.name !== 'profile.upgradeoptions' && this.$route.name !== 'profile.renewmembership') {
          location.href = config.host + '/impact'
        }
        this.showRoutes = false
      } else {
        this.showRoutes = true
      }
      if (store.getters.isCompanyAccount) {
      //   companyPromise = companyApi.getCompanyById(this.user.user_business.company_id).then((response) => {
        // console.log(this.user)
      //     this.company = response
        this.companyName = (this.user && this.user.companydata) ? this.user.companydata.company_name : ''
        this.isHivePartner = (this.user && this.user.companydata) ? (this.user.companydata.is_hive_partner) ? 1 : 0 : 0
      //   })
      }
      if (this.notShowHeaderRouteNames.includes(this.$route.name)) {
        this.showHeader = false
      } else {
        this.showHeader = true
      }
    }
    tokenPromise = null
    let notificationPromise = this.loadNotifications()
    if (this.user && this.user.user_business && this.user.account === 'user' && !this.isAdminLogin) {
      tokenPromise = tokenAPI.getNotifications({
        user_id: this.user.id,
        company_id: this.user.user_business.company_id,
        account_type: this.user.account
      })
    } else if (this.user && this.user.user_business && this.user.account === 'company' && !this.isAdminLogin) {
      tokenPromise = tokenAPI.getNotifications({
        user_id: this.user.id,
        company_id: this.user.user_business.company_id,
        account_type: this.user.account
      })
    }
    if (tokenPromise && !this.isAdminLogin) {
      tokenPromise.then((response) => {
        // console.log(response)
        // console.log(response.token_amount)
        let amount = parseFloat(response.token_amount).toFixed(2)
        if (response && amount > 0) {
          if (this.user.account === 'user' && response.display_personal_token === '0' && this.user.register_source !== 'trial-online') {
            this.$modal.show('dialog', {
              title: 'Gift',
              text: 'B1G1 Impact Tokens of $' + amount + ' has been added to your account!',
              buttons: [
                {
                  title: 'Close'
                }
              ]
            })
          }
          if (this.user.account === 'company' && response.display_company_token === '0' && this.user.register_source !== 'trial-online') {
            this.$modal.show('dialog', {
              title: 'Gift',
              text: 'B1G1 Impact Tokens of $' + amount + ' has been added to your account!',
              buttons: [
                {
                  title: 'Close'
                }
              ]
            })
          }

          // if (!this.isAdminLogin) {
          //   // userApi.hideCreditNotification(this.user.id, this.user.account)
          // }
        }
      })
    }
    if (this.user) {
      let currentThis = this
      bannerPromise = bannerAPI.getCurrentActiveBanner(['header']).then((response) => {
        this.bannerData = response ? response.header : null
        if (response.show_usd_notification) {
          this.showUSDAlert = this.getCookie('showUSDAlertBox') ? 'false' : 'true'
          this.showUSDAlert = this.notShowBanner.includes(this.$route.name) ? 'false' : 'true'
          if (this.showUSDAlert === 'true') {
            setTimeout(function () {
              let header = document.getElementById('usd-alert-box')
              if (header) {
                currentThis.showUSDHeaderOffset = header.offsetTop
                window.addEventListener('scroll', currentThis.usdNotificationBarHeaderFix)
              }
            }, 700)
          }
        }
      })
      // bannerPromise = appAPI.getPaymentConfigs().then((response) => {
      //   this.paymentConfig = response
      //   if (response.show_usd_notification) {
      //     this.showUSDAlert = this.getCookie('showUSDAlertBox') ? 'false' : 'true'
      //     this.showUSDAlert = this.notShowBanner.includes(this.$route.name) ? 'false' : 'true'
      //     if (this.showUSDAlert === 'true') {
      //       setTimeout(function () {
      //         let header = document.getElementById('usd-alert-box')
      //         if (header) {
      //           currentThis.showUSDHeaderOffset = header.offsetTop
      //           window.addEventListener('scroll', currentThis.usdNotificationBarHeaderFix)
      //         }
      //       }, 700)
      //     }
      //   }
      // })
    }

    Promise.all([companyPromise, tokenPromise, bannerPromise, companyOwnerPromise, notificationPromise]).then(() => {
      // if (/iPad|Macintosh|iPod/i.test(navigator.userAgent)) {
      //   this.isIpad = true
      // } else {
      //   this.isIpad = false
      // }
    })
  },
  mounted () {
    document.addEventListener('click', this.hidePopup)
    let currentThis = this
    $(function () {
      $('body').click(function (e) {
        if ($(e.target).closest('#myDiv').length || $(e.target).closest('#myDiv2').length) {
          if ($(e.target).closest('#myDiv2').length) {
            currentThis.showNotification = !currentThis.showNotification
          } else {
            currentThis.showNotification = true
          }
        } else {
          currentThis.showNotification = false
        }
      })
    })
    if (currentThis.$hj) {
      var userInfo = (store.getters.currentUser) ? store.getters.currentUser : null
      if (userInfo) {
        currentThis.$hj('identify', userInfo.id, {
          UserId: userInfo.id
        })
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.hidePopup)
  },
  watch: {
    'getCartCount' (to, from) {
      if (this.$route.name.indexOf('giving-cart') === -1) {
        this.animate = true
        setTimeout(() => {
          this.animate = false
        }, 2000)
      }
    },
    '$route' (to, from) {
      // this.setCurrentMenu(to.name)
    }
  },
  methods: {
    // onChange (event) {
    //   this.flagForm = !this.flagForm
    // },
    hidePopup (event) {
      if (this.$refs.popup && !this.$refs.popup.contains(event.target) && !event.target.closest('input')) {
        this.flagForm = false
      }
    },
    showCommunityTab () {
      this.showCommunity = !this.showCommunity
      this.showImpactlist = false
      document.getElementById('create-impacts-mobile').classList.remove('bg-menu-dark-active')
      if (this.showCommunity) {
        document.getElementById('community-mobile').classList.add('bg-menu-dark-active')
      }
    },
    showImpactlistTab () {
      this.showImpactlist = !this.showImpactlist
      this.showCommunity = false
      document.getElementById('community-mobile').classList.remove('bg-menu-dark-active')
      if (this.showImpactlist) {
        document.getElementById('create-impacts-mobile').classList.add('bg-menu-dark-active')
      }
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeigh
    },
    companyAccount () {
      userApi.switchAccount(this.isAdminLogin).then((response) => {
        if (response === true) {
          companyApi.getCompanyById(this.user.user_business.company_id).then((response) => {
            this.company = response
            this.companyName = (this.company) ? (this.company.company_name) ? this.company.company_name : '' : ''
            this.isHivePartner = (this.company) ? (this.company.is_hive_partner) ? 1 : 0 : 0
            this.$store.dispatch('toCompanyAccount')
            this.$store.dispatch('getCurrentUser')
            this.$router.push({name: 'home'})
            window.location.replace(config.host + '/impact')
          })
        }
      })
    },
    loadNotifications () {
      if (this.user && this.user.user_business) {
        let data = []
        data.type = (this.user.account === 'company') ? 'company' : 'personal'
        if (this.user.account === 'company') {
          data.company_id = this.user.user_business.company_id
          data.user_id = null
        } else {
          data.user_id = this.user.id
          data.company_id = null
        }
        data.limit = this.filter.limit
        data.page = this.filter.page
        let currentThis = this
        userApi.getBoradcastNotifications(data).then((response) => {
          if (response) {
            if (currentThis.notifications.length <= 0) {
              currentThis.notifications = response.data
            } else {
              response.data.forEach(function (element) {
                currentThis.notifications.push(element)
              })
            }
          }
        })
        this.loadNotificationCount()
      }
    },
    loadNotificationCount () {
      let data = []
      let currentThis = this
      data.recipient_id = (this.user.account === 'company') ? this.user.user_business.company_id : this.user.id
      data.type = (this.user.account === 'company') ? 'company' : 'personal'
      userApi.getBoradcastNotificationCount(data).then((response) => {
        if (response) {
          currentThis.cntNotification = response
        } else if (response === 0) {
          currentThis.cntNotification = response
        }
      })
    },
    getCompnayOwner () {
      if (this.user) {
        userApi.getCompnayOwner().then((response) => {
          if (response) {
            this.compnayOwnerId = response ? response.compnayOwnerId : 0
            if (!this.isAdminLogin && this.user.id !== response.compnayOwnerId && this.user.business_owner_role_id === 1) {
              this.logout()
            }
          }
        })
      }
    },
    personalAccount () {
      userApi.switchAccount(this.isAdminLogin).then((response) => {
        if (response === true) {
          this.$store.dispatch('toPersonalAccount')
          this.$store.dispatch('getCurrentUser')
          this.$router.push({name: 'home'})
          window.location.replace(config.host + '/impact')
        }
      })
    },
    personalAccountProfile () {
      userApi.switchAccount(this.isAdminLogin).then((response) => {
        if (response === true) {
          this.$store.dispatch('toPersonalAccount')
          this.$store.dispatch('getCurrentUser')
          this.$router.push({name: 'home'})
          window.location.replace(config.host + '/personal/profile')
        }
      })
    },
    openMenuDrawer () {
      this.isDrawerOpen = !this.isDrawerOpen
    },
    toggleNotification () {
      // this.showNotification = !this.showNotification
    },
    logout () {
      this.$store.dispatch('localClear')
      this.$store.dispatch('logout')
      window.location.replace(config.host + '/login')
    },
    commafyAmt (number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    loadContributions () {
      return contributionApi.get({
        impact_type: this.type,
        limit: -1
      }, ['Impact', 'Project', 'Story']).then((response) => {
        this.totalImpact = response.length > 0 ? response.map(i => i.beneficiaries).reduce((p, n) => p + n) : 0
        this.totalGivings = response.length > 0 ? response.map(i => i.amt_total_usd).reduce((p, n) => p + n) : 0
        this.totalGivingsammout = response.length > 0 ? response.map(i => i.amt_total_usd).reduce((p, n) => p + n) : 0
        this.totalGivings = this.totalGivings.toFixed(2)
      })
    },
    adminAccount () {
      let data = {
        username: atob(this.form.username),
        password: atob(this.form.password)
      }
      this.$store.dispatch('login', data).then(() => {
        location.href = config.host
      })
      document.body.classList.remove('right-menu-open')
    },
    clickRightMenuClose () {
      document.body.classList.remove('right-menu-open')
    },
    getDateFormat (date) {
      if (date) {
        return moment(String(date)).format('DD MMM YYYY')
      }
    },
    readNotification (id, notification) {
      let data = {}
      if (id === 0 && this.user.user_business) {
        data.id = 0
        data.recipient_id = (this.user.account === 'company') ? this.user.user_business.company_id : this.user.id
        data.recipient_type = (this.user.account === 'company') ? 'company' : 'personal'
      } else {
        data.id = notification.id
        data.recipient_id = notification.recipient_id
        data.recipient_type = notification.recipient_type
      }
      let currentThis = this
      if (id === 0 || (notification && notification.status === '0')) {
        userApi.readNotification(data).then((response) => {
          if (response) {
            if (response.status === 'success') {
              if (id === 0) {
                currentThis.filter.page = 1
                currentThis.cntNotification = 0
                currentThis.notifications = []
                currentThis.loadNotifications()
              } else {
                currentThis.notifications.forEach(function (element, index) {
                  if (element.id === notification.id) {
                    currentThis.notifications[index].status = '1'
                  }
                })
              }
              currentThis.loadNotificationCount()
            }
          }
        })
      }
    },
    deleteNotification (notification) {
      let data = {}
      let currentThis = this
      data.id = notification.id
      if (notification.id) {
        this.processing = true
        userApi.deleteNotification(data).then((response) => {
          if (response) {
            this.processing = false
            currentThis.filter.page = 1
            currentThis.cntNotification = 0
            currentThis.notifications = []
            currentThis.showNotification = false
            this.bToast('success', 'Notification deleted successfully.')
            currentThis.loadNotifications()
            currentThis.showNotification = true
          }
        })
      }
    },
    getCookie (name) {
      var dc = document.cookie
      var prefix = name + '='
      var begin = dc.indexOf('; ' + prefix)
      if (begin === -1) {
        begin = dc.indexOf(prefix)
        if (begin !== 0) return null
      } else {
        begin += 2
        var end = document.cookie.indexOf(';', begin)
        if (end === -1) {
          end = dc.length
        }
      }
      return decodeURI(dc.substring(begin + prefix.length, end))
    },
    handleScroll: function (el) {
      if ((el.target.offsetHeight + el.target.scrollTop) >= el.target.scrollHeight - 10) {
        this.filter.page += 1
        this.loadNotifications()
      }
    },
    externalLink (event) {
      event.stopPropagation()
    },
    // here is the code
    toggleMenu () {
      document.body.classList.toggle('left-menu-open')
      this.closeAllDropdowns()
      this.clickRightMenuClose()
    },
    toggleRightMenu () {
      document.body.classList.toggle('right-menu-open')
      document.body.classList.remove('left-menu-open')
      this.closeAllDropdowns()
    },
    closeMenu () {
      document.body.classList.remove('left-menu-open')
      document.body.classList.remove('right-menu-open')
      this.closeAllDropdowns()
    },
    closeNoti () {
      document.body.classList.remove('right-menu-open')
      document.body.classList.remove('left-menu-open')
      this.closeAllDropdowns()
    },
    closeCart () {
      document.body.classList.remove('right-menu-open')
      document.body.classList.remove('left-menu-open')
      this.closeAllDropdowns()
    },
    toggleDropdown (event) {
      const currentMenuWrapper = event.currentTarget.closest('.menu-list-wrapper')
      const allMenuWrappers = document.querySelectorAll('.menu-list-wrapper')
      allMenuWrappers.forEach(wrapper => {
        if (wrapper !== currentMenuWrapper) {
          wrapper.classList.remove('menu-dropdown')
        }
      })
      currentMenuWrapper.classList.toggle('menu-dropdown')
    },
    closeAllDropdowns () {
      const menuWrappers = document.querySelectorAll('.menu-list-wrapper')
      menuWrappers.forEach(wrapper => {
        wrapper.classList.remove('menu-dropdown')
      })
    }
  }
}

</script>

<style>
a aside {
  color: black;
}

.pointer {
  cursor: pointer;
}

.header-menu-disable {
  color: #AFAFAF !important;
  font-weight: 500;
  font-family: 'Brandon Grotesque';
  cursor: default;
}

.event_banner {
  color: #000000;
  background-color: #FFBF3E;
  height: 45px;
  text-align: center;
  max-width: 100%;
  padding: 5px;
}

.event_banner a {
  color: #000000 !important;
}

@media (min-width: 768px) and (max-width: 991px) {
  .event_banner {
    margin-bottom: -10px !important;
  }
}

@media (max-width: 460px) {
  .event_banner {
    height: auto !important;
    margin-bottom: -10px !important;
  }
}

/* .user-sec ul {
  transition: all 0.2s !important;
} */

.desktop-main-menu li:hover a i.fa-caret-down:before {
  content: "\f0d8" !important;
}

.desktop-main-menu li a i.fa-caret-down {
  margin-left: 7px;
}

.desktop-main-menu li a, .user-sec i.fa-caret-down {
  transition: all 1s;
}

.user-sec i.fas.fa-caret-down {
  position: absolute;
  top: 28px;
  right: 25px;
}

/* .user-sec:hover i.fas.fa-caret-down {
  transform: rotate(180deg);
} */

.desktop-main-menu li a + ul a {
  transition: none !important;
}

.user-sec:hover div + i.fas.fa-caret-down:before {
  content: "\f0d8" !important;
}

/* .user-sec ul {
  position: absolute;
  !*top: 100%;*!
  !*left: 50% !important;*!
  background-color: #fff;
  width: 220px;
  opacity: 0;
  visibility: hidden;
  transition: all 1s;
  z-index: 100;
  border: 1px solid #ddd;
  box-shadow: 0px 0px 6px rgb(0 0 0 / 10%);
  !*transform: translate(-50%, 0%);*!
} */

/* CSS 16-02-2022 */
.notification-blog {
  position: absolute;
  right: 40px;
  top: 100%;
  box-sizing: border-box;
  z-index: 9;
  padding: 15px 15px 20px;
  background: #FFFFFF;
  border: 1px solid #EAEAEA;
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  max-width: 377px;
  width: 100%;
}

.notification-blog h3 {
  font-family: 'Brandon Grotesque';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 29px;
    color: #000000;
    text-transform: capitalize;
}

.notification-blog > .row:first-child {
  border: 0;
  padding-top: 0;
}

.notification-blog .row {
  border-top: 1px solid #DDDDDD;
  font-family: Ubuntu;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.42px;
  color: #000000;
  padding:15px 0 10px 0;
  margin: 0;
  position: relative;
  }

.notification-title {
  font-family: 'Brandon Grotesque';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 16px;
    color: #000000;
    margin-bottom: 6px;
    text-transform: capitalize;
}
body .notification-bulets {
    padding-left: 20px !important;
}

body .notification-bulets::after {
    content: "";
    width: 8px;
    height: 8px;
    position: absolute;
    left: 0;
    top: 5px;
    background: #47BFEE;
    border-radius: 50px;
}
.notification-body {
  font-family: 'Brandon Grotesque';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  display: flex;
  align-items: center;
  letter-spacing: normal;
}

.noti_scroll .white-btn {
  padding: 0px;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border: 0 !important;
    background: #fff !important;
}
.trash-alt-wrapper {
    position: absolute;
    top: 11px;
    right: 0;
}

.trash-alt-wrapper i {
    color: #fc0057;
}
.noti_scroll {
  max-height: 360px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 60px;
  margin: 0 -15px;
  padding: 0 15px;
  scroll-behavior: smooth;
  scrollbar-width: thin;
}

.noti_scroll .noti-date {
    font-family: 'Brandon Grotesque';
    font-style: normal;
    font-weight: 420;
    font-size: 11px;
    line-height: 16px;
    color: #ABABAB;
    margin-bottom: 6px;
}

.notification-blog button {
  font-family: 'Brandon Grotesque';
  font-style: normal;
  font-weight: 420;
  font-size: 11px;
  line-height: 16px;
  color: #47BFEE;
  border: 0;
  background-color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 0;
  padding: 0;
}
.notification-blog button img {
    margin-right: 5px;
}
aside.notifation {
  text-align: center;
  height: 31px;
  line-height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}

aside.notifation div {
  display: inline-flex;
  height: auto;
  margin-left: 10px;
}
.notification-title a {
  margin-left: 6px;
}
.unreadNoti {
  cursor: pointer;
}
.notification-blog .row.readNoti [class*="col"] {
    padding: 0;
}
.notification-blog .col-6 {
    padding-left: 0;
    padding-right: 11px;
}
@media (max-width: 767px) {
  .notification-blog {
    width: auto;
    right: 15px;
  }

  .notification-blog h3 {
    font-size: 16px;
  }

  .login-btn {
    margin-right: 10px !important;
  }

  ul.desktop-main-menu.active.p-user-sec-mobile {
    text-align: left;
  }
}

.desktop-main-menu .mobile-submenu.show {
  display: block;
}

.login-btn {
  text-transform: uppercase;
  color: #000000;
  font-size: 14px;
  font-family: "Brandon Grotesque";
  font-weight: 600;
  margin-right: 20px;
}

li.b-btn.red-btn a {
  color: #fff;
  font-family: "Brandon Grotesque";
}

/*.desktop-main-menu li a {*/
/*   font-weight: 600;*/
/*}*/
.desktop-main-menu li ul {
  text-align: left;
}

.mob-right-sec {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 10px;
}

.mob-head {
  flex-wrap: nowrap !important;
}

.desktop-main-menu {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/business/Header.vue